import { Column, Columns } from '@dixa/lib-shared-habla';

import { ConversationHeader } from './components/header/conversationHeader';
import { ConversationMain } from './components/main/conversationMain';
import { ConversationSidebar } from './components/sidebar/conversationSidebar';
import styles from './conversation.module.scss';

/** Represents the conversation view component. */
export const ConversationView = (): JSX.Element => {
  return (
    <Columns>
      <Column>
        <Column.Row
          borderBottom
          noMinHeight
          noVerticalPadding
          noHorizontalPadding
        >
          <ConversationHeader />
        </Column.Row>

        <Column.Row
          className={styles.main}
          size={1}
          noMinHeight
          noVerticalPadding
          noHorizontalPadding
        >
          <ConversationMain />
        </Column.Row>
      </Column>

      <Column size="auto">
        <ConversationSidebar />
      </Column>
    </Columns>
  );
};
